/**
 * API Configuration
 * In development: requests go through Vite proxy to localhost:8787
 * In production: requests go to the API_URL environment variable
 */

export const API_BASE_URL = import.meta.env.VITE_API_URL || '';

export function getApiUrl(endpoint: string): string {
  if (!API_BASE_URL) {
    // In dev mode with Vite proxy, no base needed
    return endpoint;
  }
  // In production, use the full API URL
  return `${API_BASE_URL}${endpoint}`;
}
